export default __webpack_public_path__ + "static/media/tab-connect-participant-detail.02f381e0.png";